import React, { useEffect, useState } from "react";
import "./FloatingPromotionView.scss";
import useFetchJSONData from "@hooks/useFetchJSONData";
import useCookie from "@hooks/useCookie";

export default function FloatingPromotionView({isVisible,setIsVisible}) {
  const { data, loading, error } = useFetchJSONData("floating-promotion");
  const { setCookie, getCookie } = useCookie();

  const [isShowing, setIsShowing] = useState(false);
  const [isAccessedOnlineAcq, setIsAccessedOnlineAcq] = useState(false);

  useEffect(() => {
    const cookieAcqAccess = getCookie("acq_access");
    if (cookieAcqAccess) {
      setIsAccessedOnlineAcq(true);
    }
  }, []);

  useEffect(() => {
    setIsShowing(true);

    if(data){
      const {activePromotion,isOn} = data;

      setIsVisible(activePromotion != null && isOn)
    }else{
      setIsVisible(false)
    }
  }, [data]);

  function handleDismiss() {
    setIsShowing(false);
  }

  function handleOnTransitionEndForDismiss() {
    if (!isShowing) {
      setIsVisible(false);
    }
  }

  if (loading || error) return null;

  if (
    data === null ||
    data.activePromotion === null ||
    !data.isOn ||
    !isVisible
  )
    return null;

  const {
    isOpenInNewWindow,
    url,
    imageDesktop,
    imageMobile,
    isDisplayWhileFirstTime,
    url2,
    image2Desktop,
    image2Mobile,
  } = data.activePromotion;

  return (
    <div className="container wrapper-floating-container">
      <div
        className={`floating-container ${isShowing ? "fadeIn" : "fadeOut"}`}
        onTransitionEnd={handleOnTransitionEndForDismiss}
      >
        <a
          href={!isDisplayWhileFirstTime && isAccessedOnlineAcq ? url2 : url}
          target={isOpenInNewWindow ? "_blank" : "_self"}
        >
          <picture>
            <source
              media="(min-width:575.98px)"
              srcSet={encodeURI(
                !isDisplayWhileFirstTime && isAccessedOnlineAcq
                  ? image2Desktop
                  : imageDesktop
              )}
            />
            <img
              loading="lazy"
              src={encodeURI(
                !isDisplayWhileFirstTime && isAccessedOnlineAcq
                  ? image2Mobile
                  : imageMobile
              )}
              className="img-responsive"
            />
          </picture>
        </a>
        <div className={`btn-dismiss`} onClick={handleDismiss}>
          <span />
        </div>
      </div>
    </div>
  );
}
